$(document).ready(function () {
  $(document).on("swell:cart:updated", function () {
    window.HU__UPDATE_CART__();
  });
  if (window.location.href.indexOf("cart") > -1) {
    $('.cart__main .swell-reward-huk').css('display', 'none');
  }
  $(document).on("change", ".swell-product-list", function () {
    var variant_id = $(this).children("option:selected").data("variant-id");
    $(this).parent().parent().find(".swell-redemption-option-cost").hide();
    $("[data-variant-id='" + variant_id + "']").show();
  });

  $(document).on("change", ".swell-discount-list", function () {
    if ($(this).children("option:selected").val() == '-1') {
      $('.swell-cart-discount-dropdown .swell-redeem-btn').prop('disabled', true);
    } else {
      $('.swell-cart-discount-dropdown .swell-redeem-btn').prop('disabled', false);
    }
  });

  $(document).on("swell:setup", function () {
    $('body').on('click', ".mini-cart .content-drawer__content .cart-grid .quantity-selector", function () {
      setTimeout(function () {
        Swell.Cart.getCart(function () {
          swellAPI.refreshCustomerDetails();
        })
      }, 2000);
    });

    initializeCartDropdown();
    $(".swell-referral-loader-cart").css("display", "none");
    $(".swell-cart-redeem-section").css("display", "block");
    var redemptions = spapi.activeRedemptionOptions;
    redemptions.forEach(function (redemp) {
      if (redemp.discount_type == "cart_fixed_amount") {
        if (redemp.amount <= spapi.customer.adjusted_points_balance) {
          $(".swell-discount-list").append('<option value=' + redemp.id + '>' + redemp.name + '</option>');
        }
      }
    })
    $(".swell-discount-list").prepend("<option value='-1' selected disabled>Choose your reward</option>");

    $('body').on('click', '.swell-redemption-option_content', function () {
      if (spapi.authenticated) {
        if (beforeDiscountRedemption()) {
          var cart_total = 0;
          redemptionOptionId = $(".swell-discount-list").val();
          redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
          swellAPI.refreshCustomerDetails();
          $(document).on("swell:cart:updated", function () {
            window.HU__UPDATE_CART__();
            Swell.Cart.items.forEach(function (item) {
              if (item.properties._swell_discount_type == "cart_fixed_amount") {
                redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
                $(".mini-cart .cart-grid__items-group__items .cart__body").append('<div class="swell-cart-item cart-item relative cart__body-item"> <div class="cart-item__info relative clear align-t f"> <div class="cart-item__details"> <h4 class="h5 cart-item__details__heading">' + redeemedRedemptionOption.name + '</h4> <p class="cart-item__details__description dark-grey"><span></span></p> <p class="cart-item__details__description dark-grey"></p> <!----> <!----> <!----> <div class="cart-item__details-quantity"> <div class="f aic"> <div class="quantity-selector swell-remove-holder"><button type="button" class="swell-coupon-remove quantity-selector__action"><span>X</span></button> </div> </div> </div> </div> </div> <div class="cart-item__total"> <p class="cart-item__total-inner align-r h5">-$' + (redeemedRedemptionOption.discount_amount_cents / 100) + '</p> </div> </div>');
                $(".cart__main .cart-grid__items-group__items .cart__body").append('<div class="swell-cart-item cart-item relative cart__body-item"> <div class="cart-item__info relative clear align-t f"> <div class="cart-item__details"> <h4 class="h5 cart-item__details__heading">' + redeemedRedemptionOption.name + '</h4> <p class="cart-item__details__description dark-grey"><span></span></p> <p class="cart-item__details__description dark-grey"></p> <div class="cart-item__details-quantity"> <div class="f aic"> <div class="quantity-selector"><button type="button" class="swell-coupon-remove quantity-selector__action"><span>-</span></button> <input disabled="disabled" value="1" type="number" maxlength="2" class="quantity-selector__field"> <button disabled="disabled" type="button" class="quantity-selector__action"><span>+</span></button></div> </div> </div> </div> </div> <div class="cart-item__price hide align-t align-l"> <p class="mv05 h5">-$' + (redeemedRedemptionOption.discount_amount_cents / 100) + '</p> </div> <div class="cart-item__quantity align-t align-l"> <div class="f aic"> <div class="quantity-selector"><button disabled="disabled" type="button" class="quantity-selector__action"><span>-</span></button> <input disabled="disabled" value="1" type="number" maxlength="2" class="quantity-selector__field"> <button disabled="disabled" type="button" class="quantity-selector__action"><span>+</span></button></div> </div> <a href="" class="swell-coupon-remove p2 mt05 dark-grey underline inline-block">Remove</a> </div> <div class="cart-item__total"> <p class="cart-item__total-inner align-r h5">-$' + (redeemedRedemptionOption.discount_amount_cents / 100) + '</p> </div> </div>');
                $(".swell-redeem-btn").html('<div class="swell-redeem-btn-title">APPLY</div>');
                return
              }
            });
          });
          if (redemptionOption.amount <= spapi.customer.adjusted_points_balance) {
            Swell.Cart.items.forEach(function (item) {
              cart_total = cart_total + item.line_price;
            })
            if (redemptionOption.cart_greater_than_cents <= cart_total) {
              $(".swell-redeem-btn").html('<div class="swell-redeem-loader"><img src="//cdn.shopify.com/s/files/1/1269/8457/t/51/assets/swell-loader.svg?v=1545769155603957128"></div>');

              result = swellAPI.buyMultipleWithPoints([redemptionOption], function () {});
            } else {
              $(".swell-cart-page .swell_errormsg").css("display", "block");
            }
          } else {
            spapi.$.confirm({
              title: "Oops!",
              content: "You don't have enough points!",
              type: "red",
              typeAnimated: true,
              useBootstrap: false,
              boxWidth: "400px",
              buttons: {
                ok: {
                  text: "Ok",
                  action: function () {}
                }
              }
            });
          }
        }
      }
    });
    Swell.Cart.items.forEach(function (item) {
      if (item.properties._swell_discount_type == "cart_fixed_amount") {
        redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
        $(".mini-cart .cart-grid__items-group__items .cart__body").append('<div class="swell-cart-item cart-item relative cart__body-item"> <div class="cart-item__info relative clear align-t f"> <div class="cart-item__details"> <h4 class="h5 cart-item__details__heading">' + redeemedRedemptionOption.name + '</h4> <p class="cart-item__details__description dark-grey"><span></span></p> <p class="cart-item__details__description dark-grey"></p> <!----> <!----> <!----> <div class="cart-item__details-quantity"> <div class="f aic"> <div class="quantity-selector swell-remove-holder"><button type="button" class="swell-coupon-remove quantity-selector__action"><span>X</span></button> </div> </div> </div> </div> </div> <div class="cart-item__total"> <p class="cart-item__total-inner align-r h5">-$' + (redeemedRedemptionOption.discount_amount_cents / 100) + '</p> </div> </div>');
        $(".cart__main .cart-grid__items-group__items .cart__body").append('<div class="swell-cart-item cart-item relative cart__body-item"> <div class="cart-item__info relative clear align-t f"> <div class="cart-item__details"> <h4 class="h5 cart-item__details__heading">' + redeemedRedemptionOption.name + '</h4> <p class="cart-item__details__description dark-grey"><span></span></p> <p class="cart-item__details__description dark-grey"></p> <div class="cart-item__details-quantity"> <div class="f aic"> <div class="quantity-selector"><button type="button" class="swell-coupon-remove quantity-selector__action"><span>-</span></button> <input disabled="disabled" value="1" type="number" maxlength="2" class="quantity-selector__field"> <button disabled="disabled" type="button" class="quantity-selector__action"><span>+</span></button></div> </div> </div> </div> </div> <div class="cart-item__price hide align-t align-l"> <p class="mv05 h5">-$' + (redeemedRedemptionOption.discount_amount_cents / 100) + '</p> </div> <div class="cart-item__quantity align-t align-l"> <div class="f aic"> <div class="quantity-selector"><button disabled="disabled" type="button" class="quantity-selector__action"><span>-</span></button> <input disabled="disabled" value="1" type="number" maxlength="2" class="quantity-selector__field"> <button disabled="disabled" type="button" class="quantity-selector__action"><span>+</span></button></div> </div> <a href="" class="swell-coupon-remove p2 mt05 dark-grey underline inline-block">Remove</a> </div> <div class="cart-item__total"> <p class="cart-item__total-inner align-r h5">-$' + (redeemedRedemptionOption.discount_amount_cents / 100) + '</p> </div> </div>');
        $(".swell-redeem-btn").html('<div class="swell-redeem-btn-title">APPLY</div>');
        return
      }
    });
    $('body').on('click', ".swell-coupon-remove", function () {
      $(document).on("swell:cart:updated", function () {
        window.HU__UPDATE_CART__();
      });
      $(".swell-coupon-remove").html('<div class="swell-redeem-load-holder"><img src="//cdn.shopify.com/s/files/1/1269/8457/t/51/assets/swell-loader.svg?v=1545769155603957128"></div>');
      swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function () {});
      debugger;
      $(".swell-cart-item").remove();
    });
  })
});

function initializeCartDropdown() {
  var loggedIn1 = "";
  if (spapi.authenticated) {
    loggedIn1 = "swell-buy-product-btn"
  }
  spapi.activeRedemptionOptions.forEach(function (redemption) {
    if (redemption.discount_type == "product") {
      var id = redemption.id;
      var background_image_url = redemption.background_image_url;
      var redemption_name = redemption.name;
      var cost_text = redemption.cost_text;
      var variant_id = redemption.applies_to_id;
      var redemption_icon = redemption.icon;
      $(".swell-product-list").append("<option data-variant-id=" + variant_id + ">" + redemption_name + " (" + redemption.amount + " Points)</option>");
      $(".swell-cart-product-dropdown").append("<div class='swell-redemption-option-cost " + loggedIn1 + "' data-error-content='Looks like you dont have enough points for this product. This product costs *|amount|* points and you only have *|point_balance|* points available.' data-variant-id='" + variant_id + "'  coupon_id='" + id + "' > <a class='redeem-btn' href='javascript:void(0)'>REDEEM</a> </div>");
    }
  });
  swellAPI.refreshEmbeds();
  $(".swell-product-list").trigger('change');
}

function beforeDiscountRedemption() {
  var redeemedItemsInCart = 0;
  var regularItemsInCart = 0;
  var discountInCart = 0;

  if (Swell.Cart && Swell.Cart.items) {
    var cart = Swell.Cart;
    $.each(cart.items, function (index, item) {
      if (item.properties._swell_points_used) {
        redeemedItemsInCart++;
      } else if (item.line_price > 0) {
        regularItemsInCart++;
      }
    });

    Swell.Cart.items.forEach(function (item) {
      if (item.properties._swell_discount_type == "cart_fixed_amount") {
        discountInCart++;
      }
    });
    if (discountInCart > 0) {
      spapi.$.confirm({
        title: "Oops!",
        content: "You already have a redeemed discount in your cart.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {}
          }
        }
      });
      return false;
    } else if (regularItemsInCart == 0) {
      spapi.$.confirm({
        title: "Oops!",
        content: "You must add a priced item in your cart to redeem points for a discount.",
        type: "red",
        typeAnimated: true,
        useBootstrap: false,
        boxWidth: "400px",
        buttons: {
          ok: {
            text: "Ok",
            action: function () {}
          }
        }
      });
      return false;
    } else {
      return true;
    }
  }
};
